<div style="overflow-y: scroll; max-height: 600px;" class="col-lg-12">
    <div [formGroup]="salesCycleGroup" class="row" *ngIf="searchOpportunity">
        <epi-container class="col-lg-12" [header]="searchOpportunity.customerName + ' - ' + searchOpportunity.opportunityNotes + ' - Sales Cycle'">
            <mat-horizontal-stepper [linear]="true" #stepper>
                <div *ngIf="selectedOpp.opportunityId != null && salesCycles.length > 0 && salesCycleCheckLists.length > 0">
                    <mat-step *ngFor="let salesCycle of salesCycles" formGroupName="{{salesCycle.abbrev}}">
                        <ng-template matStepLabel>{{salesCycle.description}}</ng-template>

                        <h3 class="text-center">{{salesCycle.description}}</h3>

                        <div class="row">
                            <div class="col-lg-12">
                                <ul>
                                    <li *ngFor="let checkList of currentChecklist">
                                        <div *ngIf="salesCycleGroup.controls[salesCycle.abbrev] != null &&
                                    salesCycleGroup.controls[salesCycle.abbrev].controls[checkList.stage + 'Checkbox'] != null">
                                            <mat-checkbox formControlName="{{checkList.stage}}Checkbox" required (change)="saveChecklistMap(checkList)">{{checkList.description}}</mat-checkbox>
                                            <span>{{getCompletedChecklistTimestamp(checkList)}}</span>
                                            <textarea formControlName="{{checkList.stage}}Text" (focusout)="saveChecklistMap(checkList)" class="form-control" rows="3" cols="50" placeholder="Enter Notes..." style="display: block; max-width: 500px;"></textarea>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-2">
                                <button class="epi-button" mat-button matStepperPrevious>Back</button>
                            </div>
                            <div class="col-lg-4">
                                <mat-select placeholder="Sales Cycle" [(ngModel)]="newSalesCycleId" [ngModelOptions]="{standalone: true}">
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let salesCycle of salesCycles" [value]="salesCycle.salesCycleId">
                                        {{salesCycle.description}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div class="col-lg-4">
                                <button class="epi-button" mat-button (click)="updateSalesCycle()">Change Sales Cycle</button>
                            </div>
                            <div class="col-lg-2">
                                <button [disabled]="!isChecklistComplete(salesCycle)" class="epi-button" mat-button matStepperNext style="float: right; margin: 5px;">Next</button>
                            </div>
                        </div>
                    </mat-step>
                </div>
            </mat-horizontal-stepper>
        </epi-container>
    </div>

    <div class="row opportunity-container" [formGroup]="opportunityGroup">
        <epi-container [header]="'Opportunity'" class="col-lg-12">
            <div class="row">
                <div class="col-lg-4">
                    <ul>
                        <li>
                            <label>Opportunity Owner</label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Owner" formControlName="ownerCtrl" required>
                                    <mat-option *ngFor="let employee of employees" [value]="employee.employeeId">
                                        {{employee.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </li>
                        <li>
                            <label>Opportunity Name</label>
                            <input type="text" class="form-control input-sm" formControlName="opportunityName" />
                        </li>
                        <li>
                            <label>Close Date</label>
                            <kendo-datepicker formControlName="closeDate" style="margin: 2px;" [popupSettings]="{ appendTo: 'component' }" required></kendo-datepicker>
                        </li>
                    </ul>
                </div>

                <div class="col-lg-4">
                    <ul>
                        <li>
                            <label>Product</label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Product" formControlName="productCtrl" required>
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let product of products" [value]="product.productId">
                                        {{product.productName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="opportunityGroup.controls['productCtrl'].hasError('required')">Please select a product</mat-error>
                            </mat-form-field>
                        </li>
                        <li>
                            <label>Sales Cycle</label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Sales Cycle" formControlName="salesCycleCtrl" required disabled>
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let salesCycle of salesCycles" [value]="salesCycle.salesCycleId">
                                        {{salesCycle.description}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="opportunityGroup.controls['salesCycleCtrl'].hasError('required')">Please select a sales cycle</mat-error>
                            </mat-form-field>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-4">
                    <ul>
                        <li *ngIf="!addNewContact">
                            <label>Contact</label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Contact" formControlName="contactCtrl">
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let contact of contacts" [value]="contact.contactID">
                                        {{contact.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button class="epi-button" (click)="addNewContact = !addNewContact;">Add</button>
                        </li>
                        <li *ngIf="addNewContact" style="min-height: 275px;">
                            <label>Name</label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactName" [ngModelOptions]="{standalone: true}" />

                            <label>Phone</label>
                            <kendo-maskedtextbox [mask]="phoneMask" class="form-control input-sm" type="text" [(ngModel)]="contactPhone" [ngModelOptions]="{standalone: true}"></kendo-maskedtextbox>

                            <label>Email</label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactEmail" [ngModelOptions]="{standalone: true}" />

                            <label>Title</label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactTitle" [ngModelOptions]="{standalone: true}" />

                            <label style="color: red;">{{contactSaveMessage}}</label>
                            <button class="epi-button" (click)="$event.preventDefault(); saveContact();">Save Contact</button>
                            <button class="epi-button" (click)="addNewContact = !addNewContact;">Cancel</button>
                        </li>
                        <li>
                            <label>Est Net Revenue</label>
                            <kendo-numerictextbox [min]="0" formControlName="amountCtrl" required></kendo-numerictextbox>
                        </li>
                        <li>
                            <button class="epi-button" (click)="saveOpportunity()" style="float: right;">Save</button>
                        </li>
                        <li>
                            <p style="float: right;">{{oppMessage}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </epi-container>
    </div>

    <div class="row">
        <epi-container [header]="'Add Action'" class="col-lg-12">
            <add-customer-action [customerId]="opportunity.customerId" [opportunityId]="opportunitySalesCycleMap.opportunityId"
                                    [customerActionId]="customerActionId" (actionSaved)="customerActionSaved()"></add-customer-action>
        </epi-container>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <kendo-grid [data]="actionView"
                        [pageSize]="actionState.take"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        (dataStateChange)="actionDataStateChange($event)">
                <ng-template kendoGridToolbarTemplate>
                    <button kendoGridAddCommand>Add New Action</button>
                </ng-template>
                <kendo-grid-column field="eventDate" title="Event Date" width="60">
                    <ng-template kendoGridCellTemplate let-action>
                        {{action.eventDate | date: 'M/dd/yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="actionTypeDescription" title="Type" width="60"></kendo-grid-column>
                <kendo-grid-column field="contactName" title="Contact" width="60"></kendo-grid-column>
                <kendo-grid-column field="createdByEmployeeName" title="Created" width="60"></kendo-grid-column>
                <kendo-grid-column field="customerActionNotes" title="Notes" width="500">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{getActionNotes(dataItem)}}
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>

    <div class="row">
        <epi-container [header]="'Quote/Order Lines'" class="col-lg-12">
            <mat-select placeholder="Product">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let lineType of lineTypes" [value]="lineType.quoteOrderLineTypeId">
                    {{lineType.description}}
                </mat-option>
            </mat-select>

            <kendo-grid [data]="lineView"
                        [pageSize]="lineState.take"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        (dataStateChange)="lineDataStateChange($event)"
                        (edit)="lineEditHandler($event)"
                        (cancel)="lineCancelHandler($event)"
                        (save)="lineSaveHandler($event)">
                <kendo-grid-column title="Line" field="quoteNumber"></kendo-grid-column>
                <kendo-grid-column title="Origin" field="originCitySt"></kendo-grid-column>
                <kendo-grid-column title="Destination" field="destinationCitySt"></kendo-grid-column>
                <kendo-grid-column title="Cost" field="cost"></kendo-grid-column>
                <kendo-grid-column title="Price" field="price"></kendo-grid-column>
                <kendo-grid-column title="Type">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            {{dataItem.lineTypeDescription}}
                        </div>
                    </ng-template>
                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                        <mat-select [(ngModel)]="dataItem.quoteOrderLineTypeId">
                            <mat-option>--</mat-option>
                            <mat-option *ngFor="let lineType of lineTypes" [value]="lineType.quoteOrderLineTypeId">
                                {{lineType.description}}
                            </mat-option>
                        </mat-select>
                        <!--<kendo-dropdownlist [data]="lineTypes"
                                        [textField]="'description'"
                                        [valueField]="'quoteOrderLineTypeId'"
                                        [valuePrimitive]="true"
                                        [(ngModel)]="dataItem.quoteOrderLineTypeId">
                    </kendo-dropdownlist>-->
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-command-column>
                    <ng-template kendoGridCellTemplate let-isNew="isNew">
                        <div>
                            <button kendoGridEditCommand type="button" [primary]="true">Edit</button>
                            <button kendoGridSaveCommand type="button" [primary]="true">Save</button>
                            <button kendoGridCancelCommand type="button">Cancel</button>
                        </div>
                    </ng-template>
                </kendo-grid-command-column>
            </kendo-grid>
        </epi-container>
    </div>
</div>

